export const dropdownThemeOverrides = {
  padding: '4px 8px',
  peers: {
    Popover: {
      boxShadow: '4px 2px 24px 0px #21212126',
    },
  },
}
